import { ImageRequest } from "../../../../models";
import { ImageModel, ProviderModel } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";
export class ProviderRepo extends BaseDataRepository<ProviderModel> {
  protected baseUrl = 'provider';

  async getProvidersByUserIdAsync(): Promise<ProviderModel[]> {
    const response = await this.client.get(`${this.baseUrl}/loggedinuser`);
    return this.handleResponse<ProviderModel[]>(response)!;
  }

  async getByLocationService(locationId: number, serviceId: number): Promise<ProviderModel[] | null> {
    if (!locationId || !serviceId) return null;
    const response = await this.client.get(`${this.baseUrl}/location/${locationId}/service/${serviceId}`);
    return this.handleResponse<Promise<ProviderModel[]>>(response);
  }

  async getAvailableTimeSlots(providerId: number | null, serviceId: number, date: Date): Promise<string[] | null> {
    const response = await this.client.get(`${this.baseUrl}/${providerId}/service/${serviceId}/timeslots`, {
      params: { date: date.toISOString() },
    });
    return this.handleResponse<Promise<string[]>>(response);
  }

  async getProvidersByLocationIdAsync(id: number): Promise<ProviderModel[]> {
    const response = await this.client.get(`${this.baseUrl}/location/${id}`);
    return this.handleResponse<ProviderModel[]>(response)!;
  }
  async insertProfilePicture(item: ImageRequest): Promise<ImageModel> {
    const response = await this.client.post(`${this.baseUrl}/${item.id}/profilepicture`, item.image);
    return this.handleResponse<ImageModel>(response)!;
  }

  async deleteProfilePicture(id: number): Promise<boolean> {
    const response = await this.client.delete(`${this.baseUrl}/${id}/profilepicture`);
    return this.handleResponse<boolean>(response)!;
  }

}

export default ProviderRepo;
